module.exports = __webpack_public_path__ + "36a7423701e9d2e6728a6af14373694b.MP3";